import { Outlet } from "react-router";
import { BeakerIcon } from "@heroicons/react/20/solid";

import { ITab, Tabs } from "../../../common/Atoms/Tabs";
import { Card } from "../../../common/Atoms/Card";
import { Notification } from "../../../common/Atoms/Notification";
import { useImportLocalStoragePresets } from "../../hooks/useImportLocalStoragePresets";
import { useFeatureFlags } from "../../hooks/useFeatureFlags";
import { NotesDrawer } from "../Molecules/NotesDrawer";

const tabs: ITab[] = [
  {
    name: `Aged Receivables By Contact`,
    href: `aged`,
  },
  {
    name: `Late Fees & Interest Charges`,
    href: `latefee`,
  },
  {
    name: `Emails`,
    href: `email`,
  },
];

export function ReportsRoot() {
  // Migrate any pre-API browser-local report filter presets to the server
  useImportLocalStoragePresets();

  const featureFlags = useFeatureFlags();

  return (
    <Card>
      <Tabs
        tabs={ featureFlags.paymentPlans ? [...tabs, { name: `Payment Plans`, href: `paymentplans` }] : tabs }
      />

      <Outlet />
      { /* Reports sit outside the :organisationId route, so rows pass their organisationId to the drawer */ }
      <NotesDrawer />

      <Notification
        type={ `pro` }
        icon={ BeakerIcon }
        className={ `mt-3` }
      >
        { `Reports are new! If you have any feedback or would like to see more reports, please let us know!` }
      </Notification>
    </Card>
  );
}
